import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black shadow-lg' : 'bg-black'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-3 lg:py-4 flex items-center justify-between">
        <img 
          alt="Four Models" 
          className="h-8 sm:h-10 lg:h-12 object-contain cursor-pointer" 
          src="https://static.readdy.ai/image/103ec5ada18b00c7d95516c6aa3b7243/3c6853a00769ef0b898cf7c7be2b9fe6.png"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        />
        <div className="hidden lg:flex items-center gap-8 text-gray-400 text-sm font-medium">
          <button onClick={() => scrollToSection('quem-pode')} className="hover:text-yellow-500 transition-colors cursor-pointer whitespace-nowrap">Quem Pode</button>
          <button onClick={() => scrollToSection('historias')} className="hover:text-yellow-500 transition-colors cursor-pointer whitespace-nowrap">Depoimentos</button>
          <button onClick={() => scrollToSection('participacao-especial')} className="hover:text-yellow-500 transition-colors cursor-pointer whitespace-nowrap">Convidado</button>
        </div>
        <button onClick={() => scrollToSection('inscricao')} className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-4 sm:px-7 lg:px-8 py-2 sm:py-2.5 lg:py-3 rounded-full font-black text-xs sm:text-sm lg:text-sm hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer">
          INSCREVA-SE GRÁTIS
        </button>
      </div>
    </nav>
  );
}